import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import './GeneDrugPair.scss';

export default function GeneDrugPairIcon() {

  return (
    <span className="fa-layers fa-fw">
      <FontAwesomeIcon icon={['fas', 'circle']} className="gdPairGeneCircle" transform="left-4" />
      <FontAwesomeIcon icon={['fas', 'circle']} className="gdPairDrugCircle" transform="right-4" />
    </span>
  );
}
